//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../Features/Features.SelectFeatureList.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AlgorithmVersion",1,0],[0,"AngularTolerance",1,0],[0,"ApplicationType",1,0],[0,"LinearToleranceFactor",1,0],[0,"MirrorApproachOption",1,0],[0,"MirrorPlane",1,"Plane",0],[1,"OriginalFeatures",0,"Features.SelectFeatureList",0],[1,"OriginalParts",0,"Assemblies.SelectComponentList",0],[0,"ReportMirrorResultXML",1,0],[0,"SelectionType",1,0],[1,"TargetPart",0,"Assemblies.SelectComponentList",0]],[[["numNonBreakableCircles","nonBreakableCircles","numBrokenCircles","brokenCircles"],"SortComponentByInterPartDependency",{R_:{errorCode:''}},0,0]],[]];
SPLM.Features.ShipDesign.MirrorShipStructureBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.MirrorShipStructureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.MirrorShipStructureBuilder.VersionID = Object.freeze({
    "Undefined" : "Undefined", "Nx11" : "Nx11", "Nx12" : "Nx12"});

SPLM.Features.ShipDesign.MirrorShipStructureBuilder.Types = Object.freeze({
    "StructureSystem" : "StructureSystem", "Feature" : "Feature"});

SPLM.Features.ShipDesign.MirrorShipStructureBuilder.AppTypes = Object.freeze({
    "ShipDetailDesign" : "ShipDetailDesign", "ShipBasicDesign" : "ShipBasicDesign"});

SPLM.Features.ShipDesign.MirrorShipStructureBuilder.MirrorApproach = Object.freeze({
    "CreateLinkedMirrorBody" : "CreateLinkedMirrorBody", "CopySourceFeaturesAndReparent" : "CopySourceFeaturesAndReparent"});

export default SPLM;